import request from '@/utils/request'

export function getDevice(reqData) {
    let params = {
        dealCd: reqData.dealCd,
        entrRqstFomNo: reqData.entrRqstFomNo
    }
    return request({
        url: `/ococ/datacapture/openmarket/getDiviceModelInfo`,
        method: 'get',
        params
    })
}

export function saveAppFormTemp(reqData) {
    return request({
        url: `/ococ/datacapture/v1/openmarket/connectedCar/saveAppFormTemp`,
        method: 'post',
        data: reqData
    })
}

export function appFormEndding(reqData) {
    return request({
        url: `/ococ/datacapture/v1/openmarket/connectedCar/appFormEndding`,
        method: 'post',
        data: reqData
    })
}

export function getAppFormData(reqData) {
    let headers = {
        crypAppfNo: reqData.crypAppfNo
    }
    let params = {
        accessType: reqData.accessType,
    }
    return request({
        url: `/ococ/datacapture/openmarket/getAppFormRead`,
        method: 'get',
        headers: headers,
        params
    })
}